import React from "react";
import clsx from "clsx";
import {useTranslation} from "react-i18next";

import * as chiffresClesStyles from "../../../styles/widgets/chiffre-cle.module.scss";

const ChiffreCle = React.memo(function ChiffreCle({
                                                      figure, label, url, new_window,
                                                  }) {

    const {t} = useTranslation();

    return (<button
        aria-label={t('button.open.new_window', {
            link: `${figure} ${label}`
        })}
        className={url ? clsx(chiffresClesStyles.bloc, chiffresClesStyles.hover) : chiffresClesStyles.bloc}
        tabIndex="0"
        onClick={() => {
            if (url && typeof window !== `undefined`) window.open(url, new_window ? "_blank" : "_self");
        }}
        onKeyDown={() => {
            if (url && typeof window !== `undefined`) window.open(url, new_window ? "_blank" : "_self");
        }}
    >
        {<div className={chiffresClesStyles.root}>
            <div className={chiffresClesStyles.contentRoot}>
                <div className={chiffresClesStyles.figure}>
                    <h1
                        className={chiffresClesStyles.h1}
                    >
                        {figure}
                    </h1>
                </div>
                <div className={chiffresClesStyles.label}>
                    <p
                        className={clsx(chiffresClesStyles.h3Label, chiffresClesStyles.h2, chiffresClesStyles.nbLines)}
                    >
                        {label}
                    </p>
                </div>
            </div>
        </div>}
    </button>);
});

export default ChiffreCle;
